var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10V2h1V0H1v2h1v8l-2 2v2h5.2v6h1.6v-6H12v-2l-2-2Zm-7.2 2L4 10.8V2h4v8.8L9.2 12H2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.34c4ba169e1b31bc38ca17cdb2f3ea67.svg";
export { ForwardRef as ReactComponent };